import { Component, OnInit } from '@angular/core';
import { BaseGridTemplate } from '../../../../../shared/cgp-grid/base-cgp-grid.template';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import {
  DateTemplateService,
  FunctionalViewService,
  TimingChartControlService,
  SystemPhaseService,
  DateTemplateSystemPhaseService,
} from '../../../camtl.service';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs';
import { CgpAlertDialogService } from '../../../../../shared/cgp-alert-dialog/cgp-alert-dialog.service';


@Component({
  selector: 'app-timing-chart-control',
  templateUrl: './timing-chart-control.component.html',
  styleUrls: ['./timing-chart-control.component.scss']
})
export class TimingChartControlComponent extends BaseGridTemplate implements OnInit {

  constructor(
    private cgpAlertDialogService: CgpAlertDialogService,
    private formBuilder: FormBuilder,
    public dateTemplateService: DateTemplateService,
    public dateTemplateSystemPhaseService: DateTemplateSystemPhaseService,
    public functionalViewService: FunctionalViewService,
    public timingChartControlService: TimingChartControlService,
    public systemPhaseService: SystemPhaseService,
  ) { super() }

  selectedDateTemplate: any;
  customTemplate: any;
  hasDateTemplateChanged: boolean;
  systemPhases: any[];
  gridFilter: boolean;

  selectedSystemPhases: Subject<any[]> = new BehaviorSubject<any[]>([]);
  availablesystemPhases: Subject<any[]> = new BehaviorSubject<any[]>([]);


  ngOnInit() {
    this.dateTemplateService.read();
    this.systemPhaseService.read();
    this.selectedSystemPhases.subscribe(x => this.systemPhases = x);
  }


  handleRead = (force) => {
    let response = this.selectedDateTemplate ?
      this.timingChartControlService
        .read('/' + this.selectedDateTemplate.Id, force || this.hasDateTemplateChanged)
        .then(data => this.processView(data)) :
      Promise.resolve([]);

    this.hasDateTemplateChanged = false;
    return response;
  }


  processView(data): any[] {

    data.map(fv => {
      let current = this.systemPhaseService.value
        .filter(x => fv.SystemPhaseId.indexOf(x.Id) > -1);
      fv.SystemPhaseNames = current.map(x => x.Name);
      fv.SystemPhaseNames = fv.SystemPhaseNames.join();
    })
    // var data2 = data.SystemPhaseNames.join();
    // console.log(data2);
    return data;
  }


  handleValueChange(dataItem: any) {
    this.hasDateTemplateChanged = true;
    this.selectedDateTemplate = dataItem;
    this.template.fileName = "timing_chart_controls - " + dataItem.TemplateName + ".xlsx";
    this.gridFilter = !this.gridFilter;
    dataItem ?
      this.dateTemplateSystemPhaseService
        .read('/' + this.selectedDateTemplate.Id + '/systemphases', true) :
      this.dateTemplateSystemPhaseService.reset();
  }


  handleControlDisabled = (controlName: string) => {
    let isDisabled: boolean = false;
    switch (controlName) {
      case 'funcView':
        isDisabled = this.selectedDateTemplate === undefined;
        break;
      default:
        break;
    }
    return isDisabled;
  }


  handleSystemPhaseSortableEvent = (data) => {
    this.selectedSystemPhases.next(data);
  }


  /****************************************************************************
   * Functional View (add)
   ***************************************************************************/
  handleFunctionalView = () => {
    let form: FormGroup = new FormGroup({
      DateTemplateId: new FormControl(''),
      DateTemplateName: new FormControl(''),
      Name: new FormControl('', Validators.required),
    });

    form.reset({
      DateTemplateId: this.selectedDateTemplate.Id,
      DateTemplateName: this.selectedDateTemplate.TemplateName
    });

    this.customTemplate = {
      title: this.funcViewDialog.title,
      isNew: true,
      editForm: form,
      formControls: this.funcViewDialog.formControls,
    }
  }


  customSaveHandler(dataItem) {
    this.customTemplate = undefined;
    this.functionalViewService.save(dataItem, true, "", true, false)
      .then(response => {
        this.hasDateTemplateChanged = true;
        this.gridFilter = !this.gridFilter;
      })
      .catch(response => {
        this.functionalViewService.loading.next(false);;
        this.cgpAlertDialogService.showAlertDialog({
          title: 'Error',
          message: response._body.replace(/"/g, ''),
          alert: 'danger',
          closeLabel: 'Close',
        })
      })
  }


  customCancelHandler() {
    this.customTemplate = undefined;
  }


  funcViewDialog = {
    title: "Functional View",
    formControls: [{
      type: 'value',
      name: 'DateTemplateName',
      title: 'Date Template',
    }, {
      type: "text",
      name: "Name",
      title: "Functional View Title",
    }]
  }

  funcViewControl = {
    id: "funcView",
    iconClass: "fa fa-plus",
    title: "Add a new Functional View",
    text: "Add Functional View",
    callback: this.handleFunctionalView,
  }


  /****************************************************************************
   * Edit Dialog
   ***************************************************************************/

  editForm = this.formBuilder.group({
    FunctionViewId: [],
  })


  /**
   * Update selected system phases and include:
   * - system phases assigned to the selected functional view
   * Update available system phases and include:
   * - system phases assigned to the selected date template
   * - system phases NOT assigned to the selected functional view
   */
  updateSystemPhases(dataItem) {
    let current = this.systemPhaseService.value
      .filter(x => dataItem.SystemPhaseId.indexOf(x.Id) > -1);
    this.selectedSystemPhases.next(current);

    let available = this.systemPhaseService.value
      .filter(item => !this.systemPhases
        .some(x => x.Id === item.Id) &&
        this.dateTemplateSystemPhaseService.value
          .some(x => x.SystemPhaseId === item.Id));
    this.availablesystemPhases.next(available);
  }


  handleEdit = (dataItem, isDetailRow) => {

    this.updateSystemPhases(dataItem);
  }


  handleSystemPhaseAddSelected = (data) => {
    this.selectedSystemPhases.next(data);
  }


  handleSortableDrag = (data, e) => {
    this.selectedSystemPhases.next(data);
  }


  handleSystemPhaseRemoveSelected = (data, e) => {
    this.selectedSystemPhases.next(data);
  }


  handleSystemPhaseAddAvailable = (data, e) => {
    let dataItem = e.dataItem;
    if (dataItem.initial || dataItem.IsRequired) {
      e.preventDefault();
    }
    this.availablesystemPhases.next(data);
  }


  handleSave = (dataItem, isNew) => {
    let selected = this.systemPhases.map(x => x.Id);
    return this.systemPhaseService.save(selected, isNew, '?functionalViewId=' + dataItem.FunctionViewId, false, false, false);
  }


  handleDelete = (dataItem) => {
    return this.functionalViewService.remove('?functionalViewId=' + dataItem.FunctionViewId);
  }


  availableSystemPhasesControl = {
    zone: 'sysPhase',
    title: 'Available',
    textField: 'Name',
    valueField: 'Id',
    service: this.availablesystemPhases,
    disabledIndexes: [],
    add: this.handleSystemPhaseAddAvailable,
  };

  selectedSystemPhasesControl = {
    zone: 'sysPhase',
    title: 'Assigned',
    name: "systemPhaseDetailDto",
    emptyText: "Move System Phases from Available to Assigned.",
    textField: 'Name',
    valueField: 'Id',
    service: this.selectedSystemPhases,
    add: this.handleSystemPhaseAddSelected,
    remove: this.handleSystemPhaseRemoveSelected,
    drag: this.handleSortableDrag,
    disabledIndexes: [],
  }

  formDialog = {
    title: "System Phase",
    width: '480px',
    height: '480px',
    formControls: [{
      type: "sortable",
      title: "System Phase",
      containers: [
        this.availableSystemPhasesControl,
        this.selectedSystemPhasesControl,
      ]
    }]
  }


  columns = [
    {
      field: "FunctionViewName",
      title: "Functional View",
    },
    {
      field: "SystemPhaseNames",
      title: "System Phases",
    }
  ]

  template = {
    title: "Functional View",
    controls: {
      add: false,
      edit: true,
      delete: true,
      excel: true,
      width: 110,
      customToolbar: [
        this.funcViewControl,
      ],
      isDisabled: this.handleControlDisabled,
    },
    columns: this.columns,
    service: this.timingChartControlService,
    read: this.handleRead,
    edit: this.handleEdit,
    save: this.handleSave,
    delete: this.handleDelete,
    fileName: 'timing_chart_controls.xlsx'
  }

  setModelHandler = () => { }
}
